import React, { useState } from 'react';
import { Card, Button, Alert } from '../../../core/ui';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from '../../../core/context/TranslationContext';
import { createFamily } from '../api/family';
import { useFamily } from '../context/FamilyContext';
import styles from './CreateFamily.module.css';

export default function CreateFamily() {
  const { t } = useTranslation();
  const { refresh } = useFamily();
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setError(null);
      await createFamily(name.trim() || null);
      await refresh();
      navigate('/family');
    } catch (err) {
      setError(err.response?.data?.message || t('error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.container}>
      <Card>
        <Card.Body>
          <Card.Title>{t('family.create.title')}</Card.Title>
          {error && <Alert variant="danger">{error}</Alert>}
          <form onSubmit={handleSubmit}>
            <div className={styles.formGroup}>
              <input
                type="text"
                placeholder={t('family.create.namePlaceholder')}
                value={name}
                onChange={(e) => setName(e.target.value)}
                className={styles.input}
              />
            </div>
            <Button type="submit" variant="primary" disabled={loading}>
              {loading ? t('loading') : t('family.create.submit')}
            </Button>
          </form>
        </Card.Body>
      </Card>
    </div>
  );
}
